import { useRef, useState } from 'react';
//hooks
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';

const useAccountHook = () => {
    const { axiosPostHandler } = useAxiosHook();//axios
    /* ============================ 결제취소팝업호출 ============================ */
    const [ isOpen,setOpen ] = useState({cancel:false});
    const dataRef = useRef({});
    const onDismissHandler = (name, value, item) => {
        if(value) { dataRef.current = item !== null ? item : {}; }
        setOpen((prevState) => {
            return { ...prevState, [name]:value }
        })
    }
    /* ============================ 결제취소팝업호출 ============================ */
    return { 
        isOpen, dataRef, onDismissHandler, //결제취소 팝업 호출
    };
}

export default useAccountHook;